import Request from "../../../../../helpers/Request";

export const getLatestArtifactInfo = async (type) => {
  const response = await Request(
      "get",
      `/api/management/app-updates/oedas-dev/latest-artifact/${type}`
  );
  return response.data;
};

export default async function GetOptions() {
  const [latestFrontendUpdate, latestBackendUpdate] = await Promise.all([
    getLatestArtifactInfo("FRONTEND"),
    getLatestArtifactInfo("BACKEND"),
  ]);
  const options = {
    latestFrontendUpdate,
    latestBackendUpdate,
  };
  return options;
}
